// core
import { Component } from '@angular/core';
// plugins
import { TranslocoService } from '@jsverse/transloco';
import { RouterOutlet } from '@angular/router';

// own

@Component({
    selector: 'app-home.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    imports: [RouterOutlet]
})
export class HomeComponent {

  constructor(
    private tr: TranslocoService,
  ) {
    tr.setDefaultLang('ru');
    tr.setActiveLang('ru');
  }
}
